/**
 * Backend `access_roles.id` for the Zabihat dashboard role.
 * Set REACT_APP_ZABIHAT_ACCESS_ROLE_ID if your environment uses a different id (Store is 5).
 */
export const ZABIHAT_ACCESS_ROLE_ID = Number(process.env.REACT_APP_ZABIHAT_ACCESS_ROLE_ID) || 7;
